export { default, meta } from "C:\\Users\\user\\projects\\product-storytelling-examples\\remix\\app\\routes\\index.tsx";